module.exports = __webpack_public_path__ + "img/icon-games-white.f009aa69.svg";